<section class="pharmacy-main-container">
  <section class="pharmacy-hero-section">
    <section class="pharmacy-hero-copy">
      <span class="x-large-font font-white">Pharmacies</span>
      <p class="body-font font-white">
        Whether you are sourcing for a large health system, a stand-alone
        hospital, or an alternate site facility – it’s imperative that your
        pharmacy has the transparency and market access to medications to treat
        your patients.
      </p>
      <p class="body-font font-white">
        Now more than ever, pharmacy departments are facing pressure to reduce
        costs, while simultaneously, maintain adequate stock of medications in
        need.
      </p>
    </section>
    <section class="pharmacy-hero-image">
      <img
        src="/assets/img/static-pages/medshorts/MS_Isometric Illustrations_2-01.png"
        alt="Pharmacy Graphic Image"
      />
    </section>
  </section>
  <section class="pharmacy-main-content-section">
    <span class="large-font font-teal">
      Joining the MedShorts marketplace gives<br />
      your pharmacy a new procurement tool to<br />
      address both drug savings and shortages.
    </span>
  </section>
  <section id="pharmacy-info-section-desktop">
    <img
      id="pharmacy-infographic"
      src="/assets/img/static-pages/medshorts/static-pages-icons/Pharm Infograph.png"
      alt="Pharmacy Infographic"
    />
  </section>
  <section id="pharmacy-info-section-mobile">
    <p class="body-font font-white">
      An open<br /><span class="bold-font"
        >B2B<br />
        marketplace</span
      >
    </p>
    <img
      src="/assets/img/static-pages/medshrots/static-pages-icons/Pharm Infograph_Icon1.png"
      alt="Storefront"
    />
    <p class="body-font font-white">
      <span class="bold-font">enabling<br />direct sourcing<br /></span> from
      pharma<br />
      manufacturers
    </p>
    <img
      src="/assets/img/static-pages/medshrots/static-pages-icons/Pharm Infograph_Icon2.png"
      alt="Target"
    />
    <p class="body-font font-white">
      <span class="bold-font">streamlining<br />procurement<br /></span>for
      healthcare<br />providers
    </p>
    <img
      src="/assets/img/static-pages/medshrots/static-pages-icons/Pharm Infograph_Icon3.png"
      alt="Coin"
    />
    <p class="body-font font-white">
      <span class="bold-font">lowering drug cost<br /></span> while
      <span class="bold-font"
        >increasing<br />
        drug access</span
      >and<br /><span class="bold-font">reducing waste</span>
    </p>
    <img
      src="/assets/img/static-pages/medshrots/static-pages-icons/Pharm Infograph_Icon 4.png"
      alt="Prescription bottles"
    />
  </section>
  <section id="pharmacy-main-copy-section">
    <p class="body-font">
      Access surplus and shortage inventory from over
      <span class="bold-font">70 pharmaceutical manufacturers</span> in one
      place. your web-based portal is customized to your utilization rates to
      make shopping a breeze. Pharma manufacturers list products, assign price
      points, and monitor inventory level. Updates are immediately reflected to
      you. With such a <span class="bold-font">dynamic marketplace</span>,
      there's always something new on MedShorts.
    </p>
  </section>
  <section id="pharmacy-contact-section">
    <span class="medium-font font-teal">Start purchasing today!</span>
    <a href="/registration/buyer"
      ><button
        id="pharma-registar-btn"
        class="button-teal button-font bg-teal font-white"
      >
        Register here
      </button></a
    >
  </section>
</section>
